import { library } from "@fortawesome/fontawesome-svg-core";
import { faSearch, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from "react-router-dom";
function Dashboard() {

  library.add(faSearch, faUser);

  // Somewhere in your code, e.g. inside a handler:
    
    // const [appFeatures]=useState([{name:'location'}, {name:'hotels'}, {name:'foods'}, {name:'tradetion'}, {name:'shoping'}, {name:'tourist place'},])
    return (
      <>
        <section className="dashboardComplete">
          <div className="topHeader">
            <span className="userName"><FontAwesomeIcon icon="user" /> Shiv</span>
            <span className="searchIcn"><FontAwesomeIcon icon="search" /></span>
          </div>
    
          <div className="topHeaderText">
            <h1>Hello <b>Sibshankar</b></h1>
          </div>
          
          <div className="appsFeatures">
              <Link  to='/Location'>location</Link>
              <Link  to='/Hotels'>hotels</Link>
          </div>
    
        </section>
      </>
      
    );
  }
  
  export default Dashboard;